<template>
  <modal :show="show" @close="$emit('close')" width="605px">
    <div class="modal-header">
      <button type="button" class="close" @click="$emit('close')">
        <span aria-hidden="true">×</span>
      </button>
      <h1 v-if="title" class="modal-title">{{ title }}</h1>
    </div>
    <div class="modal-footer text">
      <p class="text" v-if="textA">{{ textA }}</p>
      <p class="text" v-if="textB">{{ textB }}</p>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'ModalTooltip',
  props: ['show', 'title', 'textA', 'textB'],
  components: {
    Modal
  }
}
</script>

<style scoped>
.text {
  font-weight: lighter;
  white-space: pre-wrap;
  text-overflow: clip;
  text-decoration-thickness: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalTooltip.vue